import React, { Component } from "react";
import { connect } from "react-redux";
import { setCurrentNavPage } from "Actions";
import PropTypes from "prop-types";

import { fetchMyMedias, fetchMyFavorites, fetchMyAlbums } from "thunks";

import MyMediasComponent from "./MyMediasComponent";
import BubblesListContainer from "../BubblesList/BubblesListContainer";
import SidebarContainer from "../Sidebar/SidebarContainer";
import { BUBBLE_EVENTS } from "Config";
import SelectAlbumContainer from "../Community/SelectAlbum/SelectAlbumContainer";
import { resetFilter } from "Actions";

export class MyMedias extends Component {
  static propTypes = {
    displaySidebarAlbums: PropTypes.bool
  };
  componentDidMount() {
    const {
      fetchMyFavorites,
      fetchMyMedias,
      fetchMyAlbums,
      resetFilter
    } = this.props;
    resetFilter();
    fetchMyFavorites({ limit: 30 });
    fetchMyMedias({ limit: 30 });
    fetchMyAlbums();
  }

  renderBubbles() {
    const bubbles = [
      {
        icon: "i-folder",
        label: "Add to album",
        event: BUBBLE_EVENTS.ADD_TO_ALBUM
      },
      {
        icon: "i-trash",
        label: "Delete selected media",
        event: BUBBLE_EVENTS.DELETE_SELECTED_MEDIAS
      }
    ];
    return <BubblesListContainer bubbles={bubbles} />;
  }
  renderSelectAlbum() {
    return <SelectAlbumContainer />;
  }

  renderSidebar() {
    const { displaySidebarAlbums } = this.props;

    if (!displaySidebarAlbums) {
      return null;
    }
    return (
      <SidebarContainer content={this.renderSelectAlbum()} withMask={true} />
    );
  }

  render() {
    const {
      community,
      albums,
      medias,
      favorites,
      filter,
      fetchMyMedias
    } = this.props;
    return (
      <div>
        <MyMediasComponent
          albums={albums}
          medias={medias}
          favorites={favorites}
          filter={filter}
          community={community}
          fetchMyMedias={fetchMyMedias}
        />
        {this.renderBubbles()}
        {this.renderSidebar()}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  filter: state.filter.filterState,
  medias: state.medias.listing,
  favorites: state.medias.images,
  albums: state.albums,
  displaySidebarAlbums: state.eventFired.displaySidebarAlbums,
  community: state.auth.navCommunity
});

const mapDispatchToProps = dispatch => ({
  setCurrentNavPage: options => dispatch(setCurrentNavPage(options)),
  fetchMyMedias: params => dispatch(fetchMyMedias(params)),
  fetchMyFavorites: params => dispatch(fetchMyFavorites(params)),
  fetchMyAlbums: () => dispatch(fetchMyAlbums()),
  resetFilter: () => dispatch(resetFilter())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyMedias);



// WEBPACK FOOTER //
// ./src/components/MyMedias/index.js